import { PencilIcon, Share2Icon, Trash2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import {
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'

import type { ProjectItemActions } from './sidebar-item-actions.interface'

interface SidebarProjectActionsMenuProps {
  projectId: string

  actions: ProjectItemActions
}

export const SidebarProjectActionsMenu = ({
  projectId,
  actions,
}: SidebarProjectActionsMenuProps): ReactNode => (
  <DropdownMenuContent side="right" align="start" className="w-48">
    <DropdownMenuGroup>
      <DropdownMenuItem onClick={() => actions.onShare(projectId)}>
        <Share2Icon />
        Share
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => actions.onRename(projectId)}>
        <PencilIcon />
        Rename
      </DropdownMenuItem>
    </DropdownMenuGroup>
    <DropdownMenuSeparator />
    <DropdownMenuItem variant="destructive" onClick={() => actions.onDelete(projectId)}>
      <Trash2Icon />
      Delete project
    </DropdownMenuItem>
  </DropdownMenuContent>
)
